export const tagOnNotesPageLoadId = () => {
  window.MyTIQ && window.MyTIQ.view({
    service_application_step: "myvodacom: fibre: fibre is available: new customer: get started: id",
    page_event: "view",
    service_application_name: "myvodacom: fibre: check coverage (transaction)",
    service_application_type: "transaction",
    page_name: "myvodacom: fibre: fibre is available: new customer: get started",
    fibre_sales_customer_type : "new"
  });
}

export const tagOnNotesPageLoadPassport = () => {
  window.MyTIQ && window.MyTIQ.view({
    service_application_step: "myvodacom: fibre: fibre is available: new customer: get started: passport",
    page_event: "view",
    service_application_name: "myvodacom: fibre: check coverage (transaction)",
    service_application_type: "transaction",
    page_name: "myvodacom: fibre: fibre is available: new customer: get started",
    fibre_sales_customer_type : "new"
  });
}

export const tagOnCreditVettingPageLoad = () => {
  window.MyTIQ && window.MyTIQ.view({
    service_application_step: "myvodacom: fibre: fibre is available: new customer: credit vetting",
    page_event: "view",
    service_application_name: "myvodacom: fibre: check coverage (transaction)",
    service_application_type: "transaction",
    page_name: "myvodacom: fibre: fibre is available: new customer: credit vetting",
    fibre_sales_customer_type : "new"
  });
}

export const tagOnSectionDetailsFillingStart = (sectionName) => {
  window.MyTIQ && window.MyTIQ.link({
    page_form_name: `myvodacom: fibre: fibre is available: new customer: credit vetting: ${sectionName}`,
    page_form_event: "started",
    fibre_sales_customer_type : "new"
  });
}

export const tagOnSectionDetailsFillingSave = (sectionName) => {
  window.MyTIQ && window.MyTIQ.link({
    page_form_name: `myvodacom: fibre: fibre is available: new customer: credit vetting: ${sectionName}`,
    page_form_event: "success",
    fibre_sales_customer_type : "new"
  });
}

export const tagOnSectionDetailsEditDetails = () => {
  window.MyTIQ && window.MyTIQ.link({
    page_tool_name: "myvodacom: fibre: fibre is available: new customer: credit vetting: edit forms",
    page_tool_event: "use",
    fibre_sales_customer_type : "new"
  });
}

export const tagOnSectionDetailsSearchBarUse = () => {
  window.MyTIQ && window.MyTIQ.link({
    page_tool_name: "myvodacom: fibre: fibre is available: new customer: credit vetting: search address",
    page_tool_event: "use",
    fibre_sales_customer_type : "new"
  });
}

export const tagOnCreditConsentCheck1 = () => {
  window.MyTIQ && window.MyTIQ.link({
    page_tool_name: "myvodacom: fibre: fibre is available: new customer: credit vetting: consent check 1",
    page_tool_event: "use",
    fibre_sales_customer_type : "new"
  });
}

export const tagOnCreditConsentCheck2 = () => {
  window.MyTIQ && window.MyTIQ.link({
    page_tool_name: "myvodacom: fibre: fibre is available: new customer: credit vetting: consent check 2",
    page_tool_event: "use",
    fibre_sales_customer_type : "new"
  });
}

export const tagOnDebiCheckNewCustomer = () => {
  window.MyTIQ && window.MyTIQ.link({
    page_tool_name: "myvodacom: fibre: fibre is available: new customer: credit vetting: debi check",
    page_tool_event: "use",
    fibre_sales_customer_type : "new"
  });
}

export const tagOnAcceptingTermsAndCondition = () => {
  window.MyTIQ && window.MyTIQ.link({
    page_tool_name: "myvodacom: fibre: fibre is available: new customer: review order: term and conditions",
    page_tool_event: "use",
    fibre_sales_customer_type: "new"
  });
}

export const tagOnErrorScreen = (errorMsg) => {
  window.MyTIQ && window.MyTIQ.view({
    page_form_event: "error",
    page_errors: [errorMsg],
    page_name: "myvodacom: fibre: fibre is available: new customer journey error",
    fibre_sales_customer_type : "new"
  });
}

export const tagOnUploadPageLoadId = () => {
  window.MyTIQ && window.MyTIQ.view({
    service_application_step: "myvodacom: fibre: fibre is available: new customer: credit vetting: upload docs",
    page_event: "view",
    service_application_name: "myvodacom: fibre: check coverage (transaction)",
    service_application_type: "transaction",
    page_name: "myvodacom: fibre: fibre is available: new customer: credit vetting: upload docs",
    fibre_sales_customer_type : "new"
  });
}

export const tagOnUploadPageLoadPassport = () => {
  window.MyTIQ && window.MyTIQ.view({
    service_application_step: "myvodacom: fibre: fibre is available: new customer: credit vetting: upload docs: passport",
    page_event: "view",
    service_application_name: "myvodacom: fibre: check coverage (transaction)",
    service_application_type: "transaction",
    page_name: "myvodacom: fibre: fibre is available: new customer: credit vetting: upload docs",
    fibre_sales_customer_type : "new"
  });
}

export const tagOnReviewOrderPageLoad = (taggingIdArray, taggingQtyArray, taggingPriceArray) => {
  window.MyTIQ && window.MyTIQ.view({
    service_application_step: "myvodacom: fibre: fibre is available: new customer: review your order",
    page_event: "view",
    service_application_name: "myvodacom: fibre: check coverage (transaction)",
    service_application_type: "transaction",
    sales_event: "order_checkout",
    sales_product_category: ['Fibre'],
    sales_product_id: taggingIdArray,
    sales_product_quantity: taggingQtyArray,
    sales_product_price: taggingPriceArray,
    page_name: "myvodacom: fibre: fibre is available: new customer: review your order",
    fibre_sales_customer_type : "new"
  });
}

export const tagOnSuccessPageLoad = (refNo, page, customerContactNo, taggingIdArray, taggingQtyArray, taggingPriceArray) => {
  window.MyTIQ && window.MyTIQ.view({
    service_application_event: "finish",
    service_application_step: "myvodacom: fibre: fibre available: new customer success",
    page_event: "view",
    service_application_name: "myvodacom: fibre: check coverage (transaction)",
    service_application_type: "transaction",
    page_name: `myvodacom: fibre: check coverage: fibre available: ${page}`,
    sales_event: "fibre_available, purchase",
    sales_order_id: [refNo],
    sales_product_category: ['Fibre'],
    sales_product_id: taggingIdArray,
    sales_product_quantity: taggingQtyArray,
    sales_product_price: taggingPriceArray,
    visitor_customer_id: [window.sha256(customerContactNo)],
    fibre_sales_customer_type : "new"
  });
}

export const tagOnBankInfoError = (errorMsg) => {
  window.MyTIQ && window.MyTIQ.view({
    page_form_event: "error", 
    page_errors: [errorMsg],
    page_name: "myvodacom: fibre: fibre is available: new customer journey: form submit error",
    fibre_sales_customer_type : "new"
  });
}

export const tagOnExitCheckout = () => {
  window.MyTIQ && window.MyTIQ.link({
    page_tool_name: "myvodacom: fibre: fibre is available: new customer: credit vetting: exit journey",
    page_tool_event: "use",
    fibre_sales_customer_type : "new"
  });
}
